var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ toggled: _vm._toggled },on:{"click":function($event){return _vm.toggle(!_vm._toggled)}}},[_c('span',[(!_vm._toggled)?_vm._t("default"):_vm._e(),(_vm._toggled)?_vm._t("toggled"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }